"use client";

import React from "react";
import { Info } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specifications = [{
  property: "Material",
  detail: "Brass (copper-zinc alloy)"
}, {
  property: "Stock gauges / thicknesses",
  detail: "{{verify: gauge/thickness list}}"
}, {
  property: "Tag sizes / shapes",
  detail: "{{verify: round/square/rectangular sizes}}"
}, {
  property: "Finishes",
  detail: "{{verify: finish list, e.g. polished, satin, natural}}"
}, {
  property: "Engraving / fill",
  detail: "Engraved, optionally paint-filled {{verify: fill color list}}"
}, {
  property: "Corrosion resistance",
  detail: "Corrosion-resistant in most facility environments (general brass trait)"
}, {
  property: "Hole / chain / mounting",
  detail: "{{verify: hole, chain, fastener, adhesive options}}"
}, {
  property: "Serialization",
  detail: "{{verify: sequential numbering / data capability}}"
}];
export default function BrassPropertiesFinishes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="brass-properties-finishes" className="bg-background py-16 md:py-24">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-8 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground tracking-tight">
            Brass Specifications
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            The brass Evermark Industrial Solutions engraves, at a glance. Confirm project-specific values against the material datasheet.
          </p>
        </div>

        <div className="rounded-lg border border-border bg-card shadow-sm overflow-hidden mb-8">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead className="w-1/3 font-semibold text-foreground text-base">
                  Property
                </TableHead>
                <TableHead className="font-semibold text-foreground text-base">
                  Detail
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {specifications.map((spec, i) => <TableRow key={i} data-index={i}>
                  <TableCell className="font-medium text-foreground align-top py-4">
                    {spec.property}
                  </TableCell>
                  <TableCell className="text-muted-foreground py-4 leading-relaxed">
                    {spec.detail}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="flex gap-4 items-start p-5 rounded-lg bg-muted/30 border border-border/50">
          <Info className="w-5 h-5 text-primary shrink-0 mt-0.5" />
          <p className="text-sm text-muted-foreground leading-relaxed">
            Values shown are for reference. Evermark Industrial Solutions recommends confirming exact tag formats, finishes, and environmental suitability for a specific application against the datasheet and with a qualified specialist for aggressive chemical environments.
          </p>
        </div>
      </div>
    </section>;
}